import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { mapSaveData, mapSkip, mapUpdate } from './map-actions-creator';
import { MapService } from '../../shared/services/map.service';
import { Store } from '@ngrx/store';
import { MapState } from './map-state';
import { LogService } from '../../../shared/services/log.service';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { ShopifyService } from '../../shared/services/shopify.service';
import { map, withLatestFrom, concatMap, tap, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Injectable()
export class MapEffects {

  loadMapData = createEffect(() => this.action$.pipe(
    ofType(mapSaveData),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    mergeMap(([_, state]) => {

      let mapState = state['app']['install']['map'];
      this.redCrossService.track('Feature Update', {
        feature: 'MAP',
        mapType: 'MAP',
        updatedSubject: mapState.subject,
        updatedBody: mapState.message,
        updatedSignature: mapState.storeName
      });

      this.trackCompleted(mapState, 'next');

      return this.mapService.saveMapData(mapState).pipe(
        tap(() => this.logger.log('MAP data saved')),
        catchError(error => {
          let errMsg = this.translate.instant('MAP.SAVE_FAILED');
          this.toastrService.error('install', 'MapEffects', errMsg, error);
          return of(mapUpdate({payload: { doneInstallation: false }}));
        }),
          map(() => mapUpdate({payload: { doneInstallation: false }})));
    })));

  skipMap = createEffect(() => this.action$.pipe(
    ofType(mapSkip),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {

      let mapState = state['app']['install']['map'];

      this.trackCompleted(mapState, 'skip');
    })),
    {
      dispatch: false
    });

  trackCompleted(mapState: MapState, ctaText: string) {
    this.shopifyService.isShopify2().subscribe(data => {
      this.redCrossService.track(REDCRSS_EVENTS.ONBOARDING, {
        category: 'Reviews',
        phaseName: 'Onboarding Step 1',
        phase: 1,
        status: 'completed',
        isEnabledMap: mapState.enabled,
        isPullPastOrdersEnabled: mapState.pastOrdersEnabled,
        numberOrders: mapState.pastOrders ? mapState.pastOrders.toString() : '0',
        isSignatureUpdated: mapState.signatureChanged,
        isSubjectUpdated: mapState.subjectChanged,
        isBodyUpdated: mapState.bodyChanged,
        ctaText: ctaText,
        os20: data.response
      });
    });
  }

  constructor(
    private action$: Actions,
    private mapService: MapService,
    private store$: Store<IAppState>,
    private logger: LogService,
    private redCrossService: AnalyticsTrackingProvider,
    private toastrService: ToastService,
    private translate: TranslateService,
    private shopifyService: ShopifyService
  ) { }
}
